import SharePop from "@/components/SharePop";
import { IconButton } from "@material-ui/core";
import ShareOutlinedIcon from "@material-ui/icons/ShareOutlined";
import React from "react";

interface IProps {
  title: string;
  url: string;
}

const ShareIcon: React.FC<IProps> = ({
  title = "placeholder",
  url = "placeholder",
}) => {
  return (
    <SharePop title={title} url={url}>
      <IconButton color="primary">
        <ShareOutlinedIcon />
      </IconButton>
    </SharePop>
  );
};

export default ShareIcon;
